import endpoints from './endpoints';
import SeattleApi from './api';
import constants from './constants';

export async function getUsername() {
    const api = new SeattleApi();
    return api.get(`${endpoints.user}/getUsername`);
}

export function logout() {
    localStorage.clear();
    window.location = '/login';
}
export async function getSchool(id) {
    const api = new SeattleApi();
    return api.get(`${endpoints.school}/${id}`);
}

export async function getSchools(queryData = null) {
    const api = new SeattleApi();
    return api.get(endpoints.school, queryData);
}

export async function getSchoolGoals() {
    const api = new SeattleApi();
    return api.get(endpoints.school_goal);
}

export async function getGoal(id) {
    const api = new SeattleApi();
    return api.get(`${endpoints.school_goal}/${id}`);
}

export async function tryAuthorization(username, password) {
    const api = new SeattleApi();
    const response = await api.post(`${endpoints.auth}/login`, { username, password });

    if (response.access_token) {
        localStorage.setItem(constants.jwtKey, response.access_token);
        localStorage.setItem(constants.roleKey, response.role);
        localStorage.setItem(constants.permissionsKey, JSON.stringify(response.permissions));
        window.location = '/dashboard';
    }
}

export function hasRole(role) {
    const userRole = localStorage.getItem(constants.roleKey);
    return role === userRole;
}

export function hasPermissions(permissions) {
    let userPermissions = localStorage.getItem(constants.permissionsKey);
    if (!userPermissions) {
        return false;
    }
    userPermissions = JSON.parse(userPermissions);
    if (!userPermissions) {
        return false;
    }
    return permissions.length ? permissions.every((val) => userPermissions.includes(val)) : false;
}

export async function getSchoolParam(schoolId, formType, columnId = '', rowId = '') {
    const api = new SeattleApi();
    return api.get(`${endpoints.school}/edit/${schoolId}/${formType}/${columnId}${rowId ? `/${rowId}` : ''}`);
}

export async function getAwsp(schoolId, rowId) {
    const api = new SeattleApi();
    return api.get(`${endpoints.school}/awsp/${schoolId}/${rowId}`);
}

export async function updateAwsp(schoolId, rowId, awsp) {
    const api = new SeattleApi();
    return api.post(`${endpoints.school}/awsp/${schoolId}/${rowId}`, { awsp });
}

export async function getMatrixLabelData(schoolId, matrixLabelId, formType) {
    const api = new SeattleApi();
    return api.get(`${endpoints.school}/matrix-label-edit/${formType}/${schoolId}/${matrixLabelId}`);
}

export async function setMatrixLabelData(schoolId, matrixLabelId, formType, data) {
    const api = new SeattleApi();
    return api.post(`${endpoints.school}/matrix-label-edit/${formType}/${schoolId}/${matrixLabelId}`, data);
}
export async function validateJwt() {
    const api = new SeattleApi();
    return api.get(`${endpoints.auth}/validate`);
}

export async function updateSchoolParam(schoolId, data, formType, columnId = '', rowId = '') {
    const api = new SeattleApi();
    return api.post(`${endpoints.school}/edit/${schoolId}/${formType}/${columnId}${rowId ? `/${rowId}` : ''}`, data);
}

export async function getGoals(type, formType, query = null, schoolId = '') {
    const api = new SeattleApi();
    return api.get(`${endpoints.school_goal}/items/${type}/${formType}/${schoolId}`, query);
}

export async function getSchoolWithColumns(formType, schoolId = '', query = null) {
    const api = new SeattleApi();
    return api.get(`${endpoints.school}/with-columns/${formType}/${schoolId}`, query);
}

export async function getFormType(formType) {
    const api = new SeattleApi();
    return api.get(`${endpoints.form_type}/${formType}`);
}

export async function getUsers() {
    const api = new SeattleApi();
    return api.get(`${endpoints.user}/`);
}

export async function getUser(userId) {
    const api = new SeattleApi();
    return api.get(`${endpoints.user}/${userId}`);
}

export async function updateUser(userId, userData) {
    const api = new SeattleApi();
    return api.put(`${endpoints.user}/${userId}`, userData);
}

export async function createUser(userData) {
    const api = new SeattleApi();
    return api.post(endpoints.user, userData);
}

export async function deleteUser(path, userId) {
    const api = new SeattleApi();
    const endpoint = endpoints.user + path;
    return api.post(endpoint, { _id: userId });
}

export async function uploadSchoolDocument(schoolId, formData, formType, columnId, rowId = '') {
    const api = new SeattleApi();
    return api.postForm(`${endpoints.school}/upload/${schoolId}/${formType}/${columnId}/${rowId}`, formData);
}

export async function removeSchoolDocument(schoolId, documentName, formType, columnId, rowId = '') {
    const api = new SeattleApi();
    return api.delete(`${endpoints.school}/upload/${schoolId}/${formType}/${columnId}/${rowId}`, {
        fileName: documentName,
    });
}

export async function getSchoolMeta(schoolId, metaKey) {
    const api = new SeattleApi();
    return api.get(`${endpoints.school_meta}/${schoolId}/${metaKey}`);
}

export async function updateSchoolMeta(schoolId, metaKey, data) {
    const api = new SeattleApi();
    return api.post(`${endpoints.school_meta}/${schoolId}/${metaKey}`, data);
}

export async function updateFormTemplate(formType, template) {
    const api = new SeattleApi();
    return api.post(`${endpoints.form_type}/${formType}`, template);
}
